import { customLiftListItem } from "../../../commands/custom-commands";
//import { liftListItem } from "prosemirror-schema-list";
import { customSchema } from "../../../schemas/custom-schema";

export default class IndentListButton {
  constructor(editorView, containerElement) {
    this.view = editorView;
    this.buttonElement = document.createElement("button");
    this.buttonElement.setAttribute("type", "button");
    this.buttonElement.className = "editor-toolbar-button disabled--hidden";
    this.buttonElement.title = "Desanidar";
    this.buttonElement.dataset.action = "outdent";
    const iconSpan = document.createElement("span"),
      labelSpan = document.createElement("span");
    iconSpan.textContent = "Desanidar";
    labelSpan.className = "oculto-visual";
    labelSpan.textContent = "Desanidar";
    this.buttonElement.appendChild(iconSpan);
    this.buttonElement.appendChild(labelSpan);
    this.buttonAction = this.buttonClickCallback();
    this.rejectFocusAction = this.buttonMouseDownCallback();
    this.buttonElement.addEventListener("click", this.buttonAction);
    this.buttonElement.addEventListener("mousedown", this.rejectFocusAction);
    containerElement.appendChild(this.buttonElement);
    this.update(editorView);
  }

  update(view) {
    const isEnabled = customLiftListItem(customSchema.nodes.listItem)(view.state, null);
    this.buttonElement.disabled = !isEnabled;
    this.view = view;
  }

  destroy() {
    this.buttonElement.removeEventListener("click", this.buttonAction);
    this.buttonElement.removeEventListener("mousedown", this.rejectFocusAction);
    this.buttonElement.remove();
    this.buttonElement = null;
    this.buttonAction = null;
    this.rejectFocusAction = null;
    this.view = null;
  }

  buttonMouseDownCallback() {
    return (event) => {
      event.preventDefault();
    }
  }

  buttonClickCallback() {
    return () => {
      customLiftListItem(customSchema.nodes.listItem)(this.view.state, this.view.dispatch);
    }
  }
}
